export enum InformationField {
  Emails = 'emails',
  Phones = 'phones',
  SocialLinks = 'socialLinks',
  Links = 'links',
}
